// removed by extract-text-webpack-plugin
module.exports = {"offsetBackground":"src-components-wrappers-OffsetBackground-style----general-module---offsetBackground---1YYIz position-relative","content":"src-components-wrappers-OffsetBackground-style----general-module---content---3Cbwn position-relative zi-weak","bg":"src-components-wrappers-OffsetBackground-style----general-module---bg---14MZn pinBL position-absolute width-100"};


//////////////////
// WEBPACK FOOTER
// ./src/components/wrappers/OffsetBackground/style/general.module.css
// module id = 1496
// module chunks = 168707334958949